import Seo from "@components/seo";
import ContactFormArea from "@containers/contact/layout-05";
import ContactArea from "@containers/contact/layout-08";
import PageHeader from "@containers/page-header/layout-02";
import HeadTeamArea from "@containers/team/layout-02";
import ExecutiveTeamArea from "@containers/team/layout-03";
import EmployeTeamArea from "@containers/team/layout-04";
import Layout from "@layout";
import Footer from "@layout/footer/layout-01";
import Header from "@layout/header/layout-05";
import { normalizedData } from "@utils";
import { graphql } from "gatsby";
import PropTypes from "prop-types";
import React from "react";

const LeadershipPage = ({ pageContext, location, data }) => {
    const content = normalizedData(data?.page?.content || []);
    const globalContent = normalizedData(data?.allGeneral.nodes || []);

    return (
        <Layout location={location}>
            <Seo title="Leadership" />
            <Header
                data={{
                    ...globalContent["header"],
                    ...globalContent["menu"],
                }}
            />
            <main className="site-wrapper-reveal">
                <PageHeader
                    pageContext={pageContext}
                    location={location}
                    title="Leadership"
                />
                <ContactFormArea data={content["contact-form-section"]} />
                <HeadTeamArea data={content["head-section"]} />
                <ExecutiveTeamArea data={content["executive-section"]} />
                <EmployeTeamArea data={content["employee-section"]} />
                <ContactArea data={globalContent["contact"]} />
            </main>
            <Footer data={{ ...data.site.siteMetadata }} />
        </Layout>
    );
};

export const query = graphql`
    query LeadershipPageQuery {
        allGeneral {
            nodes {
                section
                ...GeneralOne
            }
        }
        site {
            ...Site
        }
        page(title: { eq: "leadership" }, pageType: { eq: "innerpage" }) {
            content {
                ...PageContent
            }
        }
    }
`;

LeadershipPage.propTypes = {
    pageContext: PropTypes.shape({}),
    location: PropTypes.shape({}),
    data: PropTypes.shape({
        allGeneral: PropTypes.shape({
            nodes: PropTypes.arrayOf(PropTypes.shape({})),
        }),
        site: PropTypes.shape({
            siteMetadata: PropTypes.shape({
                contact: PropTypes.shape({}),
            }),
        }),
        page: PropTypes.shape({
            content: PropTypes.arrayOf(PropTypes.shape({})),
        }),
    }),
};

export default LeadershipPage;
